<template lang="pug">
.logout-content
  h2.logout-title {{ translateString('logoutSuccessMessage') }}
  h5.logout-redirect-text(v-html='translateString("logoutRedirectMessage", { seconds: countdown })')
  KetchUpButton.primary.ketch-w-auto(@click.native='$router.push("/")')
    h5 {{ $t('stayLoggedIn') }}
</template>

<script setup lang="ts">
  import { ref, onMounted, onUnmounted } from 'vue'

  import KetchUpButton from '@/components/common/KetchUpButton.vue'

  import useI18n from '@/composables/useI18n'
  import { UserModule } from '@/store/modules/user'
  import useCommonMixin from '@/composables/useCommonMixin'

  const { translateString } = useI18n()
  const { hasValidUser } = useCommonMixin()

  const countdown = ref(10)

  let countdownInterval: NodeJS.Timeout | null = null

  const handleLogout = async () => {
    await UserModule.logout()
    window.location.href = '/login'
  }

  const startCountdown = async () => {
    countdownInterval = setInterval(() => {
      countdown.value--

      if (countdown.value <= 0) {
        clearInterval(countdownInterval!)
        handleLogout()
      }
    }, 1000)
  }

  onMounted(() => {
    if (hasValidUser.value) {
      startCountdown()
    } else {
      handleLogout()
    }
  })

  onUnmounted(() => {
    if (countdownInterval) {
      clearInterval(countdownInterval)
    }
  })
</script>

<style lang="postcss" scoped>
  .logout-content {
    @apply ketch-flex ketch-flex-col ketch-space-y-c20 ketch-items-center ketch-justify-center;

    .logout-title {
      @apply ketch-font-bold;
    }

    .logout-redirect-text {
      @apply ketch-text-center ketch-max-w-[280px];
    }
  }
</style>
